import { defineBlock } from "eddev/blocks"
import { Container, Grid, Col } from "@components/layout/Grid"
import { ManualCards } from "@components/molecules/Cards"
import * as iconList from "@components/atoms/Icons"

export const meta: BlockMeta = {
  title: "Single card container",
  category: "common",
  icon: "format-image",
  keywords: ["card"],
  tags: ["root"],
  editMode: "preview",
  lazyLoad: false,
  conditions: {
    postTypes: ["page", "post"],
  },
}

export default defineBlock("general/card-single", (props) => {
  return (
    <Container className="py-6">
      <Grid>
        <Col initial={12}>
          <ManualCards
            type="single"
            title={props?.title ?? undefined}
            content={props.content ?? undefined}
            chip={{
              color: "grey",
              children: props?.chipText ?? undefined,
            }}
            image={props?.image ?? undefined}
            imagePosition={props?.imagePosition ? true : false}
            primaryLink={{
              color: "yellow",
              size: "medium",
              children: props.mainLink?.title ?? undefined,
              href: props.mainLink?.url ?? undefined,
              target: props.mainLink?.target ? "_blank" : undefined,
              icon: (props?.mainLinkIcon as keyof typeof iconList) ?? undefined,
              iconStyle: "right",
            }}
            secondaryLink={{
              color: "grey",
              size: "medium",
              children: props.secondaryLink?.title ?? undefined,
              href: props.secondaryLink?.url ?? undefined,
              target: props.secondaryLink?.target ? "_blank" : undefined,
              icon: (props?.secondaryLinkIcon as keyof typeof iconList) ?? undefined,
              iconStyle: "right",
            }}
          />
        </Col>
      </Grid>
    </Container>
  )
})
